// Type minimal couvrant AuthError de @supabase/auth-js sans dépendre du paquet.
type AuthErrorLike = {
  status?: number;
  code?: string;
  message?: string;
} | null;

export function translateAuthError(err: AuthErrorLike): string {
  if (!err) return "Une erreur est survenue. Réessaie.";
  if (err.status === 429) {
    return "Trop de demandes. Patiente quelques minutes avant de réessayer.";
  }
  if (err.code === "invalid_credentials") {
    return "Email ou mot de passe incorrect.";
  }
  if (err.code === "otp_expired") {
    return "Ce code n'est plus valable. Si tu as demandé plusieurs codes, utilise le dernier reçu.";
  }
  if (err.code === "current_password_required") {
    return "Le mot de passe actuel est requis pour modifier ton mot de passe.";
  }
  if (err.code === "current_password_mismatch") {
    return "Le mot de passe actuel est incorrect.";
  }
  return err.message ?? "Une erreur est survenue. Réessaie.";
}
